import { render, staticRenderFns } from "./BrigadeAutoAssignWorkTypes.vue?vue&type=template&id=7a7b7310&"
import script from "./BrigadeAutoAssignWorkTypes.vue?vue&type=script&lang=js&"
export * from "./BrigadeAutoAssignWorkTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QItem} from 'quasar'
component.options.components = Object.assign({QItem}, component.options.components || {})
